import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { GlobalConsts } from 'src/app/shared/global.vars';
import { StorageService } from './storage.service';
import { LogedInUserModel } from 'src/app/models';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AppRedirectService {

  constructor(
    private router: Router,
    private storageService: StorageService,
    private loginService: UserService
  ) {
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const oldUserProfile = await this.storageService.getValue(GlobalConsts.UserProfileLsKey);

    if (oldUserProfile) {

      const userProfile = await this.loginService.reloginUser(oldUserProfile as LogedInUserModel).toPromise();

      if (userProfile.UserToken !== null) {
        this.router.navigateByUrl('/remotes');
        return false;
      }
    }

    return true;
  }
}
